// extracted by mini-css-extract-plugin
module.exports = {"loader":"loading_loader__5nMo_","animloader":"loading_animloader__jEm_i"};